import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { Component, OnInit, Injectable, SecurityContext } from "@angular/core";
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";
import { AppRoutingModule } from "../app-routing.module";
import { AppSettings } from "../modules/core/configs/core.config";
import { LoginService } from "../modules/login/login.service";
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from "@angular/router";
import { NgDompurifySanitizer } from '@tinkoff/ng-dompurify';
import { ConfigService } from "../modules/core/configs/config.service";
import { AuthOWAService } from "../modules/core/services/auth-owa.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Outlook Web Access';
  public isLoading!: boolean;

  constructor(
    public loginService: LoginService,
    router: Router,
    private appRoutingModule: AppRoutingModule,
    private authOWAService: AuthOWAService
    ) {
    const navStart = router.events.pipe(
      filter((evt: any) => evt instanceof NavigationStart),
    ) as Observable<NavigationStart>;
  
    const navEnd: Observable<NavigationStart> = router.events.pipe(
      filter(
        (evt: any) =>
          evt instanceof NavigationEnd ||
          evt instanceof NavigationCancel ||
          evt instanceof NavigationError,
      ),
    ) as Observable<NavigationStart>;

    navStart.subscribe(() => (this.isLoading = true));
    navEnd.subscribe(() => (this.isLoading = false));

    this.appRoutingModule.getNavigationStatus().subscribe((status: boolean) => {
      this.isLoading = status;
    });

    this.authOWAService.setSpinnerLoading.subscribe((value:boolean) => {
      (this.isLoading = value);
    });

  }
  async ngOnInit(): Promise<void> {
  }
}
@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  config = ConfigService;
  constructor(private dompurifySanitizer: NgDompurifySanitizer) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({ withCredentials: true });
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (request.url === AppSettings.authOWA) {
          setTimeout(() => {
            window.location.href = this.dompurifySanitizer.sanitize(SecurityContext.URL, this.config.authOWA_Url + '/owa/');
          }, 2000);
        }
        return event;
      }));
  }
}
